import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl } from '@shared/helpers/form.helper';
import { Utilities } from '@core/helpers/utilities';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { debounceTime, merge, startWith } from 'rxjs';
import { getContribLegge59Control } from '../validators/helpers/contrib-legge-59-92-form.helpers';
import { cloneDeep } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';

export const setContribLegge59RisultatoEsercizioListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const flags = [false, true];
    flags.forEach((isAnno2) => {
        my_RisultEsercizioHelper(form, store, isAnno2);
    });
};

/** VBS (aggiornoRisultEsercizio): precarica il risultato d'esercizio dal conto economico del bilancio.
 * Se TipoSchemaBil è vuoto o "V" (schema abbreviato) usa CoEcF26x, altrimenti CoEcF23x. */
const my_RisultEsercizioHelper = (form: FormGroup, store: Store<Revisione53State>, isAnno2: boolean): void => {
    const suffix = isAnno2 ? '2' : '1';
    const targetFieldName = isAnno2 ? 'my_RisultEsercizio' : 'my_RisultEsercizioAnno1';
    const contoEconomico = `${formPaths.datiBilancio}.my_ContoEconomico`;

    const tipoSchema = getControl(form, `${formPaths.datiBilancio}.my_TipoSchemaBil${suffix}`);
    const coEcF26 = getControl(form, `${contoEconomico}.my_CoEcF26${suffix}`);
    const coEcF23 = getControl(form, `${contoEconomico}.my_CoEcF23${suffix}`);
    const targetControl = getContribLegge59Control(form, targetFieldName);

    merge(
        tipoSchema.valueChanges.pipe(startWith(tipoSchema?.value ?? null)),
        coEcF26.valueChanges.pipe(startWith(coEcF26?.value ?? null)),
        coEcF23.valueChanges.pipe(startWith(coEcF23?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const risultEsercizio = isNilOrEmpty(tipoSchema.value) || tipoSchema.value === 'V' ? coEcF26.value : coEcF23.value;
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                targetControl.patchValue(risultEsercizio ?? '', { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[targetFieldName] = risultEsercizio ?? '';
                return myVerbaleClone;
            });
        });
};
